// import get_MAC, { isMAC } from 'getmac'
// import { getMacAddressAsync } from 'expo-network';
// getMacAddressAsync().then((v) => {
//     console.log(v);
//    });

import { data } from '../constants/Constants';
import { notificacion } from './util';

class device {
    constructor(props) {
        this.Mac = ""
    }

    getMacCookie() {
        let cookies = document.cookie.split(';').filter(x => x != '')
            .map(x => {
                let [key, value] = x.trim().split('=');
                return { key, value };
            });

        let cookieMAC = cookies.find(x => x.key == 'mc');

        if (cookieMAC == null || cookieMAC.value == "") cookieMAC = null;
        else {
            cookieMAC = cookieMAC.value;
        }

        return cookieMAC;
    }

    async getMac(fn, CorreoElectronico, SO, Browser) {
        // let cookies = document.cookie.split(';').filter(x => x != '')
        //     .map(x => {
        //         let [key, value] = x.trim().split('=');
        //         return { key, value };
        //     });

        // let cookieMAC = cookies.find(x => x.key == 'mc');
        let cookieMAC = this.getMacCookie();

        if (cookieMAC == null) {
            let res = await fn({ CorreoElectronico, SO, Browser });
            if (res.mo.type == "success") {
                cookieMAC = res.dto.codigoDispositivo;
                device.prototype.Mac = cookieMAC;
                document.cookie = "mc=" + cookieMAC;
            } else {
                await notificacion('Login', res.mo.listMessage.join(", "));
                // cookieMAC = cookieMAC.value;
                // device.prototype.Mac = cookieMAC;
            }
        } else {
            cookieMAC = cookieMAC;
            device.prototype.Mac = cookieMAC;
        }

        return cookieMAC;
        // const nPromise = get_MAC()
        //     .then((v) => {
        //         debugger;
        //         console.log(v);
        //         return v;
        //     });
        // return nPromise;

    }
}
export default device;